var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-settings-menu-group" } },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    " + _vm._s(_vm.group.title) + "\n  "),
      ]),
      _vm._v(" "),
      _vm._l(_vm.group.items, function (item) {
        return _c(
          "or-menu-item",
          {
            key: item.id,
            class: { "is-active": _vm.isItemActive(item) },
            attrs: {
              icon: item.icon,
              selected: _vm.isItemActive(item),
              "data-nav": "settings-menu-tab",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("item-click", item.id)
              },
            },
          },
          [_vm._v("\n    " + _vm._s(item.label) + "\n  ")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }